export default "__VITE_ASSET__tWW6_Agh__"